import { Body1, Dialog, Stack } from '@axon-enterprise/spark';
import { Box, IconButton, SvgIcon, SvgIconProps, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';

const APP_VERSION = process.env.REACT_APP_VERSION?.trim() || '—';

const InfoOutlineSvg: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
  </SvgIcon>
);

const AboutAppInfo: React.FC = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          zIndex: theme.zIndex.fab,
          bottom: { xs: 12, sm: 20 },
          right: { xs: 12, sm: 20 },
        }}
      >
        <IconButton
          onClick={() => setOpen(true)}
          color="primary"
          size={isXs ? 'small' : 'medium'}
          aria-label={__('View app version information')}
        >
          <InfoOutlineSvg fontSize={isXs ? 'small' : 'medium'} />
        </IconButton>
      </Box>
      <Dialog
        open={open}
        title={__('About this app')}
        onClose={() => setOpen(false)}
        primaryAction={undefined}
        secondaryAction={null}
      >
        <Stack space="m">
          <Body1>{__('Share this app version when you contact support.')}</Body1>
          <Stack space="s">
            <InfoRow label={__('App version')} value={APP_VERSION} />
          </Stack>
        </Stack>
      </Dialog>
    </>
  );
};

const InfoRow: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="body2" fontFamily="ui-monospace, Menlo, monospace">
      {value}
    </Typography>
  </Box>
);

AboutAppInfo.displayName = 'AboutAppInfo';

export default AboutAppInfo;
